/**
 * PDP back link (sections/main-product.liquid, .tt-back).
 *
 * The anchor's href is set server-side to a real fallback destination
 * (the product's first collection, or /collections/all) so it always
 * works with JS disabled and stays crawlable. On click, if we can tell
 * the shopper actually came from somewhere else on this site, we hijack
 * the click and call history.back() instead — that lands them exactly
 * where they were (scroll position, filters, etc.) rather than the
 * generic fallback collection.
 *
 * The referrer gate is the whole point: document.referrer is empty for
 * direct landings (typed URL, bookmark) and won't start with our own
 * origin for shoppers arriving from an ad, a shared link, search, or
 * social. In those cases history.back() would either no-op (nothing
 * behind us in this tab) or send them back out of the site entirely —
 * both wrong. Falling through to the plain href keeps that traffic on
 * the site instead.
 */
(function () {
  var link = document.querySelector('.tt-back');
  if (!link) return;

  link.addEventListener('click', function (event) {
    var cameFromThisSite =
      document.referrer &&
      document.referrer.indexOf(location.origin) === 0 &&
      history.length > 1;

    if (cameFromThisSite) {
      event.preventDefault();
      history.back();
    }
    // Otherwise let the anchor navigate normally to its href.
  });
})();
